import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();
const authorizationBearer = TokenService.getAuthorizationBearer();

export const MitigationAPIService = {
    updateMitigation: async function (mitigationView) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Mitigations/UpdateMitigation', {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(mitigationView)
            });
            
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('There was an error', error);
                console.log(mitigationView);
            }
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },   
};